import axios from 'axios';
import { useNavigate } from 'react-router';
import TokenService from './token.service';
// export const  WS_URL = "ws://127.0.0.1:40080/ws"
// export const  WS_URL = "wss://pb3chat.hope-xxl.com/ws"
export const  WS_URL = window.location.hostname === 'gdw.projectboek.nl' ? "wss://gdwchat.projectboek.nl/ws" : (window.location.hostname === 'proof.projectboek.nl' ? "wss://proofchat.projectboek.nl/ws" : "wss://pb3chat.hope-xxl.com/ws")
const baseUrl = window.location.hostname === 'proof.projectboek.nl' ? 'https://proofapi.projectboek.nl/' : (window.location.hostname === 'gdw.projectboek.nl' ? 'https://gdwapi.projectboek.nl/' : (window.location.hostname === 'test.projectboek.nl' ? 'https://testapi.projectboek.nl/' : (window.location.hostname == 'localhost' ? 'http://localhost:8000/' : 'https://pb3api.hope-xxl.com/' )))
const instance = axios.create({
  // baseURL: 'http://localhost:8000/',
  // baseURL: 'http://fastapi.localhost/',
  // baseURL: 'https://pb3api.hope-xxl.com/',
  baseURL: baseUrl, // 'https://testapi.projectboek.nl/',
  // baseURL: 'https://proofapi.projectboek.nl/',
  // baseURL: 'https://api.hope-xxl.com/',
  headers: {
    'Content-Type': 'application/json'
  }
});
// const navigate = useNavigate()

instance.interceptors.request.use(
  (config) => {
    console.log(config.url);
    if (config.url === '/auth/refresh') {
      return config;
    }
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token; // for Spring Boot back-end
      //   config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    console.log(err)
    const originalConfig = err.config;
    if (originalConfig.url === '/auth/refresh' && (err.response.status === 401 || err.response.status == 422)) {
      // navigate('/login')
      console.log('User has to reauthenticate.');
      TokenService.removeUser();
      window.location.reload();
      return Promise.reject(err);
    }

    if (originalConfig.url !== '/auth/login' && originalConfig.url !== '/auth/login_mfa' && err.response) {
      // Access Token was expired
      if ((err.response.status === 401 || err.response.status == 422) && !originalConfig._retry) {
        originalConfig._retry = true;
        try {
          return instance
            .post(
              '/auth/refresh',
              {
                refreshToken: TokenService.getLocalRefreshToken()
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + TokenService.getLocalRefreshToken()
                }
              }
            )
            .then((res) => {
              if (res.status === 200) {
                TokenService.updateLocalAccessToken(res.data);
                return instance(originalConfig);
              }
            });
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
